import api from '@/api'

const { $core } = api;
const $st = api.$student

export const { $student } = $st
export const { $rules} = $core